import { render, staticRenderFns } from "./LicitacaoVisualizacao.vue?vue&type=template&id=f7da2fb8&"
import script from "./LicitacaoVisualizacao.vue?vue&type=script&lang=js&"
export * from "./LicitacaoVisualizacao.vue?vue&type=script&lang=js&"
import style0 from "./LicitacaoVisualizacao.vue?vue&type=style&index=0&id=f7da2fb8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports